/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * 这是一个JSON对象，里面必须包含一个名为 `content` 的字段。这个字段的值，就是你希望格式化的、原始的JSON字符串。
 */
export type PostConvertJsonRequest = { content: string };

export const PostConvertJsonRequest$zodSchema: z.ZodType<
  PostConvertJsonRequest
> = z.object({
  content: z.string(),
}).describe(
  "这是一个JSON对象，里面必须包含一个名为 `content` 的字段。这个字段的值，就是你希望格式化的、原始的JSON字符串。",
);

/**
 * 包含错误详情的对象。
 */
export type PostConvertJsonDetails = {};

export const PostConvertJsonDetails$zodSchema: z.ZodType<
  PostConvertJsonDetails
> = z.object({}).describe("包含错误详情的对象。");

/**
 * 请求失败。这通常意味着你提供的 `content` 字符串不是一个合法的JSON格式。请检查括号、引号是否匹配，以及末尾是否有多余的逗号等常见错误。
 */
export type PostConvertJsonBadRequestResponseBody = {
  code?: string | undefined;
  details?: PostConvertJsonDetails | undefined;
  message?: string | undefined;
};

export const PostConvertJsonBadRequestResponseBody$zodSchema: z.ZodType<
  PostConvertJsonBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => PostConvertJsonDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "请求失败。这通常意味着你提供的 `content` 字符串不是一个合法的JSON格式。请检查括号、引号是否匹配，以及末尾是否有多余的逗号等常见错误。",
);

/**
 * 格式化成功！返回一个包含美化后JSON字符串的对象。
 */
export type PostConvertJsonResponseBody = { content?: string | undefined };

export const PostConvertJsonResponseBody$zodSchema: z.ZodType<
  PostConvertJsonResponseBody
> = z.object({
  content: z.string().optional(),
}).describe("格式化成功！返回一个包含美化后JSON字符串的对象。");

export type PostConvertJsonResponse =
  | PostConvertJsonResponseBody
  | PostConvertJsonBadRequestResponseBody;

export const PostConvertJsonResponse$zodSchema: z.ZodType<
  PostConvertJsonResponse
> = z.union([
  z.lazy(() => PostConvertJsonResponseBody$zodSchema),
  z.lazy(() => PostConvertJsonBadRequestResponseBody$zodSchema),
]);
